import React from "react";
import {
  arrayOf,
  number,
  objectOf,
  oneOfType,
  string,
  func,
  bool
} from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { 
  Dialog,
  DialogTitle, 
  DialogActions, 
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Button,
  Input,
  TableHead
  } from "@material-ui/core";

import Close from "@material-ui/icons/Close";
import Search from "@material-ui/icons/Search";
import Shuffle from "@material-ui/icons/Shuffle";
import DatePicker from "components/DatePicker";
import _ from "lodash";
import cx from "classnames";
import { getReassignApi } from "../../../helpers/campaignApi";
import { convertTimezoneDate } from "../../../helpers/formatData";
import moment from 'moment-timezone';
import styles from "./styles.scss";
import { REASSIGN_GET_ID } from '../../../helpers/constant';
import { DEFAULT_TIME_ZONE_KEY } from 'components/TimeZoneSelector/constants';

const customStyle = theme => ({
  dialog: {
    margin: "150px auto",
    width: "700px",
    height: "550px",
    display: "flex",
    flexDirection: "column"
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
  }
})


class ReassignModal extends React.Component {
  static defaultProps = {
    onChange: _.noop,
  }
  
  state = {
    reassignCreativeList: [],
    loadedReassignCreativeList: false,
    loading: false,
    creativeReassignTo: {},
    searchValue: ""
  }

  componentDidMount() {
    const { campaign, changeDateRange } = this.props;
    const { campaign_id, start_date, end_date } = campaign;
    if (!campaign.summaryDrillDownCalendar) {
      changeDateRange(
        campaign_id,
        {start: new Date (start_date), end: new Date(end_date)},
        "summaryDrillDownCalendar",
        -1
      )
    }
  }

  componentDidUpdate = prevProps => {
    const { open } = this.props;
    const { open: prevOpen } = prevProps;
    const { loadedReassignCreativeList, loading } = this.state;
    if (!open && prevOpen ) {
      this.setState({ searchValue: '' })
    }
    if (open) {
      const { detailUrl, campaign } = this.props;
      const convertKey = ["creative_name", "type_id", "creative_duration"];
      const timezoneKey = _.get(campaign, 'timezoneSetting.timezoneKey', DEFAULT_TIME_ZONE_KEY);
      const startDate = convertTimezoneDate(_.get(campaign, 'summaryDrillDownCalendar.selected.start'), timezoneKey, true);
      const endDate = convertTimezoneDate(_.get(campaign, 'summaryDrillDownCalendar.selected.end'), timezoneKey, false);
      const { selected: preSelectedDrilldown } = prevProps.campaign.summaryDrillDownCalendar;
      const isDrillDownDateChange = !((startDate === convertTimezoneDate(preSelectedDrilldown.start, timezoneKey, true))
                                    && endDate === convertTimezoneDate(preSelectedDrilldown.end, timezoneKey, false));
     
      if (isDrillDownDateChange ? isDrillDownDateChange : (!loadedReassignCreativeList && !loading)) {
      this.setState({loading: true, loadedReassignCreativeList: false});
      getReassignApi(
        detailUrl.urlApi,
        campaign.advertiser_id,
        campaign.campaign_id,
        REASSIGN_GET_ID,
        startDate,
        endDate
      ).then(
        res => {
          const reassignCreativeList = res.data.map(item => _.pick(item, convertKey));
          return this.setState({
            reassignCreativeList,
            loadedReassignCreativeList: true,
            loading: false,
            searchValue: ''
          })
        })
      }
    }
  }


  handleSearchReassign = event => {
    const searchValue = event.target.value;
    this.setState({
      searchValue
    })
  }

  handleClickReassignCreativeButton = (creativeReassignTo = {}) => event => {
    const { mentionsToReassign,
      updateSummaryDrillDownSaga,
      campaign,
      advertiser,
      paramGetData,
    } = this.props;
    const { frozenExcludeList,
      frozenReassignList,
      frozenDataMentions,
     } = campaign.dataDrillDown;

    let reassignListChange = [...frozenReassignList];

    /* eslint lodash/matches-shorthand: [2, "never"] */
    const groupOfReassignItemIndex = _.findIndex(
      reassignListChange,
      item => (item.assignTo.toCreativeName === creativeReassignTo.creative_name && item.assignTo.creative_duration === creativeReassignTo.creative_duration)
    );

    if (groupOfReassignItemIndex >= 0) {
      reassignListChange = reassignListChange.map((item, index) => ({
        ...item,
        gen_key: groupOfReassignItemIndex === index ? _.union(item.gen_key, mentionsToReassign) : item.gen_key
      }))
    } else {
      reassignListChange.push({
        "gen_key": mentionsToReassign,
        "assignTo": {
          "toCreativeName": creativeReassignTo.creative_name,
          "type": creativeReassignTo.type_id,
          "creative_duration": creativeReassignTo.creative_duration
        }
      })
    }

    const reassignJobTitleMessage = _.find(frozenDataMentions, ['gen_key', mentionsToReassign[0]]).mention_name +
          (mentionsToReassign.length === 1 ? " has" : " and " + (mentionsToReassign.length - 1) + " other have") + " been reassigned";
    const summaryJobTitle = {
      includeJobTitleMessage: "",
      excludeJobTitleMessage: "",
      reassignJobTitleMessage
    }
    const messageSnackbar = <span>
          {mentionsToReassign.length}
          {(mentionsToReassign.length === 1 ? " instance was" : " instances were") + " moved to " + creativeReassignTo.creative_name}
          <br />
          Your data will refresh to reflect the update.
        </span>
    this.props.handleReassignItems(summaryJobTitle, reassignListChange);
    updateSummaryDrillDownSaga({
      excludeMentionList: frozenExcludeList,
      reassignMentionsList: reassignListChange,
      campaign,
      advertiser,
      summaryJobTitle,
      messageSnackbar,
      mentionsToReassign,
      paramGetData
    });
  }

  render() {
   const {
      onChange,
      setEditingCondition,
      campaign,
      classes,
      changeDateRange,
      advertiser,
      handleCloseReassignDialog,
      ...props } = this.props;

    const {
      loading,
      loadedReassignCreativeList,
      reassignCreativeList,
      searchValue
    } = this.state;
    const reassignCreativeListShow = reassignCreativeList.filter(item => _.includes(item.creative_name.toLowerCase(), searchValue.toLowerCase()));

    return (
      <div>
        <Dialog
          className={cx(classes.dialog)}
          fullScreen
          onClose={handleCloseReassignDialog}
          {...props}
        >
          <DialogTitle 
            className={cx(classes.dialogTitle, styles["dialog-title"])} 
            onClose={this.handleClose}
            disableTypography
          >
            <span>
              Reassign to Pre-Recorded Spots
            </span>
            <div className={classes.dialogTitle}>
              <DatePicker
              onChange={onChange}
              advertiser={advertiser}
              edit={false}
              campaign={campaign}
              typePicker={{ name: "summaryDrillDownCalendar" }}
              isShowDataCollected
              changeDateRange={changeDateRange}
              setEditingCondition={setEditingCondition}
              customSelect
              selected={
                _.get(
                  campaign,
                  "summaryDrillDownCalendar.selected",
                )
              }
              value={
                _.get(
                  campaign,
                  "summaryDrillDownCalendar.value",
                )
              }
              />
              <Button onClick={handleCloseReassignDialog}>
                <Close/>
              </Button>
            </div>
          </DialogTitle>
          <DialogContent className={styles["dialog-content"]}>
            <div className={styles["search-area"]}>
                <Search/>
                <Input 
                disableUnderline 
                fullWidth
                onChange={this.handleSearchReassign}
                value={searchValue}
                />
            </div>
            <div className={styles["content-table"]}>
            {loading && <span>Loading ... </span>}
            {loadedReassignCreativeList && 
            (reassignCreativeListShow.length === 0
              ?
              <span>No item found</span>
              :
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className={styles.nameContainer}>
                      Creative Name
                    </TableCell>
                    <TableCell className={styles.durationContainer}>
                      Duration
                    </TableCell>
                    <TableCell className={styles["reassign-area"]}>
                      {""}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {
                  reassignCreativeListShow.map((creative, index) => (
                  <TableRow key={`${creative}-${index.toString()}`}>
                    <TableCell className={styles.nameContainer}>
                        {creative.creative_name}
                    </TableCell>
                    <TableCell className={styles.durationContainer}>
                      {creative.creative_duration}
                    </TableCell>
                    <TableCell className={styles["reassign-area"]}>
                      <Button onClick={this.handleClickReassignCreativeButton(creative)}> 
                        <Shuffle/>
                        Reassign
                      </Button>
                    </TableCell>
                  </TableRow>
                  ))
                }
                </TableBody>
              </Table>
              )
            }
            </div>
          </DialogContent>
          <DialogActions className={styles["dialog-action"]}>
            <Button onClick={handleCloseReassignDialog}>
                Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

ReassignModal.propTypes = {
  headerMaps: objectOf(string),
  mentions: arrayOf(objectOf(oneOfType([string, number]))),
  selectMediaId: func,
  media_id: number,
  indexSourch: number,
  isOpenSourch: bool,
  onChange: func,
};

export default withStyles(customStyle)(ReassignModal);
